var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardMask = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 253,
    viewBox: "0 0 400 253",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "card-mask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.716 6.712 0 14.996 0h370.008C393.286 0 400 6.725 400 15v222.632c0 8.284-6.712 15-14.996 15H14.996c-8.282 0-14.996-6.725-14.996-15V15zm336.97 174.09c26.777 0 48.485-21.706 48.485-48.484 0-26.777-21.708-48.485-48.485-48.485-26.778 0-48.485 21.71-48.485 48.486 0 26.778 21.707 48.485 48.485 48.485z",
    fill: "#2A264F",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#83EA8D",
    strokeWidth: 4,
    cx: 336.973,
    cy: 140.606,
    r: 46.485
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardMask);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-mask.77caeff1fd130385a57b43a364293f64.svg";